
import React, { useState, useEffect, useRef } from 'react'
import CONSTANTS from '../../../constants';
import { CheckBox, Button } from '../../Forms/Forms';

const ServicesFilter = (props) => {
    let checkedStyle = props.selectedPremiumServices.length > 0 ? 'filterChecked' : ''
    const [isFilterOpen, setIsFilterOpen] = useState('hidden')

    const myRef = useRef(null)

    const toggleClassOpen = (event) => {
        if (event instanceof KeyboardEvent && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }
        let FilterClass = isFilterOpen === "hidden" ? "open" : "hidden";
        setIsFilterOpen(FilterClass);


    }
    const handleClickOutside = (e) => {
        if (!myRef.current.contains(e.target)) {
            setIsFilterOpen('hidden')
        }
    }

    useEffect(() => {

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside);

    }, [])

    return (
        <div className="custom-select-wrapper" >
            <div className={`custom-select ${isFilterOpen}`} ref={myRef}>
                <div onClick={toggleClassOpen} role="button" aria-pressed="mixed" tabIndex="0" onKeyPress={(event) => toggleClassOpen(event)} className={`custom-select__trigger ${checkedStyle}`}>
                    <span>{CONSTANTS.LABELS.dealer_locator_filter_main}</span>
                    <span className="arrow"></span>
                </div>
                {isFilterOpen === 'open' && <div className="custom-options">
                    {
                        props.listPremiumServices.map(premiumService => {
                            return (
                                premiumService.displayDL && <CheckBox key={premiumService.idServicePremium} wrapperClasses={`custom-option`}
                                    id={premiumService.idServicePremium}
                                    onClick={(e) => {
                                        props.onAddOrRemoveToFilter(premiumService.idServicePremium, e.target.checked)
                                    }
                                    }
                                    label={premiumService.titre}
                                    isChecked={props.selectedPremiumServices.includes(premiumService.idServicePremium)}
                                />
                            )
                        })
                    }
                    <div className="form-ligne submit-button">
                        <Button onClick={() => {
                            props.onApplyFilter();
                            toggleClassOpen()
                        }
                        }
                        >
                            {CONSTANTS.LABELS.dealer_locator_filter_apply}
                        </Button>
                    </div>
                </div>}
            </div>
        </div>
    );
}
export default ServicesFilter;